import { computed } from 'vue';
import { AuthenticationProviderType } from '@/domain/enums/authentication-provider-type';
import Actions from '@/dictionary/tracking/actions';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { SocialIncentiveButtonsBase } from '../SocialIncentiveButtonsBase.class';
import { FacebookClient } from '@/infrastructure/clients/facebook/facebook-client';

declare const FACEBOOK_APP_ID: string;

export default class FacebookSigninButton extends SocialIncentiveButtonsBase {
	public pending = computed((): boolean => {
		return this.store.getters.pending();
	});
	public template: string;


	protected readonly buttonName = 'FacebookButton';

	constructor(store: IIncentiveV2Store, isRegistration: boolean, template = 'Small') {
		super(store, isRegistration);
		this.template = template;
	}

	public async authenticate(): Promise<void> {
		const result = await new FacebookClient(FACEBOOK_APP_ID).login();
		await this.signInWithProvider({
			provider: AuthenticationProviderType.FACEBOOK,
			facebookAccessToken: result.code,
		});
		this.trackButtonClick(Actions.FACEBOOK_BUTTON_CLICK);
	}
}
